;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import Script from 'next/script';

export default function HubSpotTracking() {
  const hubspotId = process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID || '26847356';

  if (!hubspotId) return null;

  return (
    <Script
      type="text/javascript"
      id="hs-script-loader"
      src={`https://js-eu1.hs-scripts.com/${hubspotId}.js`}
      strategy="afterInteractive"
      async
      defer
    />
  );
}
